// components/Common/BreadcrumbAboveImage
import React from "react"
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { Row, Col, BreadcrumbItem } from "reactstrap"

const BreadcrumbAboveImage = props => {
  // Determine the column size class based on the prop, default to "col-12"
  const colClass = props.colSize ? `col-${props.colSize}` : "col-12";

  const renderBreadcrumbs = () => {
    if (props.breadcrumbItems && props.breadcrumbItems.length > 0) {
      return props.breadcrumbItems.map((item, index) => {
        const isLast = index === props.breadcrumbItems.length - 1;
        return (
          <BreadcrumbItem key={index} /*active={isLast}*/>
            {item.to && !isLast ? 
              <Link to={item.to}>{['undefined', ''].includes(item.title) ? '...' : item.title}</Link> : 
              <Link to={`#`}>{['undefined', ''].includes(item.title) ? '...' : item.title}</Link>
            }
          </BreadcrumbItem>
        );
      });
    } else {
      // fallback to single breadcrumbItem for backward compatibility
      return (
        <>
          <BreadcrumbItem>
            <Link to="#">{props.title}</Link>
          </BreadcrumbItem>
          <BreadcrumbItem active>
            <Link to="#">{props.breadcrumbItem || ''}</Link>
          </BreadcrumbItem>
        </>
      );
    }
  };

  return (
    <Row>
      <Col className={colClass}>

        {/* Show when xs */}
        <div className="page-title-box d-sm-none"
          style={{
            background: "#eaeaea",
            padding: "10px 20px",
            marginBottom: "24px",
            opacity: "0.92",
            clipPath: "polygon(2.5% 0, 100% 0, 97.5% 100%, 0 100%)"
          }}
        >
          <h4 className="ms-2 font-size-18">
            {props.title
              || (props.breadcrumbItems && props.breadcrumbItems[props.breadcrumbItems?.length-1].title) 
              || props.breadcrumbItem}
          </h4>
          <div className="page-title-right">
            <ol className="breadcrumb m-0">
              {renderBreadcrumbs()}
            </ol>
          </div>
        </div>

        {/* Show when >=sm */}
        <div className="page-title-box d-none d-sm-flex align-items-center justify-content-between">
          <div style={{
            background: "#eaeaea",
            padding: "7px 10px",
            opacity: "0.92",
            clipPath: "polygon(5% 0, 100% 0, 95% 100%, 0 100%)"
          }}>
            <h4 className="ms-3 me-3 mb-sm-0 font-size-18">
              {props.title
                || (props.breadcrumbItems && props.breadcrumbItems[props.breadcrumbItems?.length-1].title) 
                || props.breadcrumbItem}
            </h4>
          </div>
          <div className="page-title-right"
            style={{
              background: "#eaeaea",
              padding: "7px 17px",
              opacity: "0.95",
              clipPath: "polygon(3% 0, 100% 0, 97% 100%, 0 100%)"
            }}
          >
            <ol className="breadcrumb m-0">
             {renderBreadcrumbs()}
            </ol>
          </div>
        </div>

      </Col>
    </Row>
  )
}

BreadcrumbAboveImage.propTypes = {
  title: PropTypes.string,
  breadcrumbItem: PropTypes.string,
  breadcrumbItems: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    to: PropTypes.string, // optional: if not present, render as active
  })),
  colSize: PropTypes.string,
}

export default BreadcrumbAboveImage;







